// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AeoRouteImport } from './routes/aeo'
import { Route as AeoChecklistRouteImport } from './routes/aeo-checklist'
import { Route as AiActionPlanRouteImport } from './routes/ai-action-plan'
import { Route as AiAnswersRouteImport } from './routes/ai-answers'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BangladeshSeoRouteImport } from './routes/bangladesh-seo'
import { Route as BestDigitalMarketingExpertBangladeshRouteImport } from './routes/best-digital-marketing-expert-bangladesh'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as BnRouteImport } from './routes/bn'
import { Route as BookRouteImport } from './routes/book'
import { Route as CaseStudiesRouteImport } from './routes/case-studies'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CredentialsRouteImport } from './routes/credentials'
import { Route as FreeSeoAuditRouteImport } from './routes/free-seo-audit'
import { Route as GlossaryRouteImport } from './routes/glossary'
import { Route as HowToCheckDomainAuthorityRouteImport } from './routes/how-to-check-domain-authority'
import { Route as HowToImproveDomainAuthorityRouteImport } from './routes/how-to-improve-domain-authority'
import { Route as MozDaVsAhrefsDrRouteImport } from './routes/moz-da-vs-ahrefs-dr'
import { Route as OnlineMarketingSmallBusinessesRouteImport } from './routes/online-marketing-small-businesses'
import { Route as PressRouteImport } from './routes/press'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProcessRouteImport } from './routes/process'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as SeoExpertBangladeshRouteImport } from './routes/seo-expert-bangladesh'
import { Route as SeoForRouteImport } from './routes/seo-for'
import { Route as SeoLocationsRouteImport } from './routes/seo-locations'
import { Route as SeoServicesBangladeshRouteImport } from './routes/seo-services-bangladesh'
import { Route as SeoToolsRouteImport } from './routes/seo-tools'
import { Route as SeoTrainingRouteImport } from './routes/seo-training'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SitemapRouteImport } from './routes/sitemap'
import { Route as TestimonialsRouteImport } from './routes/testimonials'
import { Route as TrustRouteImport } from './routes/trust'
import { Route as WhatIsDigitalMarketingRouteImport } from './routes/what-is-digital-marketing'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BnIndexRouteImport } from './routes/bn.index'
import { Route as BnAboutRouteImport } from './routes/bn.about'
import { Route as BnAiActionPlanRouteImport } from './routes/bn.ai-action-plan'
import { Route as BnBookRouteImport } from './routes/bn.book'
import { Route as BnCaseStudiesRouteImport } from './routes/bn.case-studies'
import { Route as BnContactRouteImport } from './routes/bn.contact'
import { Route as BnFreeSeoAuditRouteImport } from './routes/bn.free-seo-audit'
import { Route as BnOnlineMarketingSmallBusinessesRouteImport } from './routes/bn.online-marketing-small-businesses'
import { Route as BnPricingRouteImport } from './routes/bn.pricing'
import { Route as BnServicesRouteImport } from './routes/bn.services'
import { Route as CaseStudiesIndexRouteImport } from './routes/case-studies.index'
import { Route as CaseStudiesSlugRouteImport } from './routes/case-studies.$slug'
import { Route as CompareIndexRouteImport } from './routes/compare.index'
import { Route as CompareSlugRouteImport } from './routes/compare.$slug'
import { Route as ProofIndexRouteImport } from './routes/proof.index'
import { Route as ProofSlugRouteImport } from './routes/proof.$slug'
import { Route as SeoForIndexRouteImport } from './routes/seo-for.index'
import { Route as SeoForIndustryRouteImport } from './routes/seo-for.$industry'
import { Route as SeoServicesIndexRouteImport } from './routes/seo-services.index'
import { Route as SeoServicesLocationRouteImport } from './routes/seo-services.$location'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesAeoRouteImport } from './routes/services.aeo'
import { Route as ServicesAeoGeoRouteImport } from './routes/services.aeo-geo'
import { Route as ServicesDigitalMarketingRouteImport } from './routes/services.digital-marketing'
import { Route as ServicesGeoRouteImport } from './routes/services.geo'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as ToolsRobotsTesterRouteImport } from './routes/tools.robots-tester'
import { Route as ToolsSchemaGeneratorRouteImport } from './routes/tools.schema-generator'
import { Route as ToolsSerpSimulatorRouteImport } from './routes/tools.serp-simulator'
import { Route as BlogCategoryCategoryRouteImport } from './routes/blog.category.$category'
import { Route as BnBlogIndexRouteImport } from './routes/bn.blog.index'
import { Route as BnBlogSlugRouteImport } from './routes/bn.blog.$slug'
import { Route as BnCaseStudiesIndexRouteImport } from './routes/bn.case-studies.index'
import { Route as BnCaseStudiesSlugRouteImport } from './routes/bn.case-studies.$slug'
import { Route as BnSeoServicesIndexRouteImport } from './routes/bn.seo-services.index'
import { Route as BnSeoServicesLocationRouteImport } from './routes/bn.seo-services.$location'
import { Route as BnServicesIndexRouteImport } from './routes/bn.services.index'
import { Route as BnServicesAeoRouteImport } from './routes/bn.services.aeo'
import { Route as BnServicesGeoRouteImport } from './routes/bn.services.geo'
import { Route as BnServicesSeoRouteImport } from './routes/bn.services.seo'
import { Route as SeoServicesLocationServiceRouteImport } from './routes/seo-services.$location.$service'
import { Route as SeoServicesRangpurAreaRouteImport } from './routes/seo-services.rangpur.$area'
import { Route as BnBlogCategoryCategoryRouteImport } from './routes/bn.blog.category.$category'
import { Route as BnSeoServicesLocationServiceRouteImport } from './routes/bn.seo-services.$location.$service'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AeoRoute = AeoRouteImport.update({
            id: '/aeo',path: '/aeo',getParentRoute: () => rootRouteImport
          })
const AeoChecklistRoute = AeoChecklistRouteImport.update({
            id: '/aeo-checklist',path: '/aeo-checklist',getParentRoute: () => rootRouteImport
          })
const AiActionPlanRoute = AiActionPlanRouteImport.update({
            id: '/ai-action-plan',path: '/ai-action-plan',getParentRoute: () => rootRouteImport
          })
const AiAnswersRoute = AiAnswersRouteImport.update({
            id: '/ai-answers',path: '/ai-answers',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BangladeshSeoRoute = BangladeshSeoRouteImport.update({
            id: '/bangladesh-seo',path: '/bangladesh-seo',getParentRoute: () => rootRouteImport
          })
const BestDigitalMarketingExpertBangladeshRoute = BestDigitalMarketingExpertBangladeshRouteImport.update({
            id: '/best-digital-marketing-expert-bangladesh',path: '/best-digital-marketing-expert-bangladesh',getParentRoute: () => rootRouteImport
          })
const BlogRoute = BlogRouteImport.update({
            id: '/blog',path: '/blog',getParentRoute: () => rootRouteImport
          })
const BnRoute = BnRouteImport.update({
            id: '/bn',path: '/bn',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const CaseStudiesRoute = CaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CredentialsRoute = CredentialsRouteImport.update({
            id: '/credentials',path: '/credentials',getParentRoute: () => rootRouteImport
          })
const FreeSeoAuditRoute = FreeSeoAuditRouteImport.update({
            id: '/free-seo-audit',path: '/free-seo-audit',getParentRoute: () => rootRouteImport
          })
const GlossaryRoute = GlossaryRouteImport.update({
            id: '/glossary',path: '/glossary',getParentRoute: () => rootRouteImport
          })
const HowToCheckDomainAuthorityRoute = HowToCheckDomainAuthorityRouteImport.update({
            id: '/how-to-check-domain-authority',path: '/how-to-check-domain-authority',getParentRoute: () => rootRouteImport
          })
const HowToImproveDomainAuthorityRoute = HowToImproveDomainAuthorityRouteImport.update({
            id: '/how-to-improve-domain-authority',path: '/how-to-improve-domain-authority',getParentRoute: () => rootRouteImport
          })
const MozDaVsAhrefsDrRoute = MozDaVsAhrefsDrRouteImport.update({
            id: '/moz-da-vs-ahrefs-dr',path: '/moz-da-vs-ahrefs-dr',getParentRoute: () => rootRouteImport
          })
const OnlineMarketingSmallBusinessesRoute = OnlineMarketingSmallBusinessesRouteImport.update({
            id: '/online-marketing-small-businesses',path: '/online-marketing-small-businesses',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProcessRoute = ProcessRouteImport.update({
            id: '/process',path: '/process',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const SeoExpertBangladeshRoute = SeoExpertBangladeshRouteImport.update({
            id: '/seo-expert-bangladesh',path: '/seo-expert-bangladesh',getParentRoute: () => rootRouteImport
          })
const SeoForRoute = SeoForRouteImport.update({
            id: '/seo-for',path: '/seo-for',getParentRoute: () => rootRouteImport
          })
const SeoLocationsRoute = SeoLocationsRouteImport.update({
            id: '/seo-locations',path: '/seo-locations',getParentRoute: () => rootRouteImport
          })
const SeoServicesBangladeshRoute = SeoServicesBangladeshRouteImport.update({
            id: '/seo-services-bangladesh',path: '/seo-services-bangladesh',getParentRoute: () => rootRouteImport
          })
const SeoToolsRoute = SeoToolsRouteImport.update({
            id: '/seo-tools',path: '/seo-tools',getParentRoute: () => rootRouteImport
          })
const SeoTrainingRoute = SeoTrainingRouteImport.update({
            id: '/seo-training',path: '/seo-training',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const SitemapRoute = SitemapRouteImport.update({
            id: '/sitemap',path: '/sitemap',getParentRoute: () => rootRouteImport
          })
const TestimonialsRoute = TestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => rootRouteImport
          })
const TrustRoute = TrustRouteImport.update({
            id: '/trust',path: '/trust',getParentRoute: () => rootRouteImport
          })
const WhatIsDigitalMarketingRoute = WhatIsDigitalMarketingRouteImport.update({
            id: '/what-is-digital-marketing',path: '/what-is-digital-marketing',getParentRoute: () => rootRouteImport
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/admin/leads',path: '/admin/leads',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BlogRoute
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BlogRoute
          })
const BnIndexRoute = BnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BnRoute
          })
const BnAboutRoute = BnAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => BnRoute
          })
const BnAiActionPlanRoute = BnAiActionPlanRouteImport.update({
            id: '/ai-action-plan',path: '/ai-action-plan',getParentRoute: () => BnRoute
          })
const BnBookRoute = BnBookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => BnRoute
          })
const BnCaseStudiesRoute = BnCaseStudiesRouteImport.update({
            id: '/case-studies',path: '/case-studies',getParentRoute: () => BnRoute
          })
const BnContactRoute = BnContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => BnRoute
          })
const BnFreeSeoAuditRoute = BnFreeSeoAuditRouteImport.update({
            id: '/free-seo-audit',path: '/free-seo-audit',getParentRoute: () => BnRoute
          })
const BnOnlineMarketingSmallBusinessesRoute = BnOnlineMarketingSmallBusinessesRouteImport.update({
            id: '/online-marketing-small-businesses',path: '/online-marketing-small-businesses',getParentRoute: () => BnRoute
          })
const BnPricingRoute = BnPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => BnRoute
          })
const BnServicesRoute = BnServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => BnRoute
          })
const CaseStudiesIndexRoute = CaseStudiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CaseStudiesRoute
          })
const CaseStudiesSlugRoute = CaseStudiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => CaseStudiesRoute
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const ProofIndexRoute = ProofIndexRouteImport.update({
            id: '/proof/',path: '/proof/',getParentRoute: () => rootRouteImport
          })
const ProofSlugRoute = ProofSlugRouteImport.update({
            id: '/proof/$slug',path: '/proof/$slug',getParentRoute: () => rootRouteImport
          })
const SeoForIndexRoute = SeoForIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SeoForRoute
          })
const SeoForIndustryRoute = SeoForIndustryRouteImport.update({
            id: '/$industry',path: '/$industry',getParentRoute: () => SeoForRoute
          })
const SeoServicesIndexRoute = SeoServicesIndexRouteImport.update({
            id: '/seo-services/',path: '/seo-services/',getParentRoute: () => rootRouteImport
          })
const SeoServicesLocationRoute = SeoServicesLocationRouteImport.update({
            id: '/seo-services/$location',path: '/seo-services/$location',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ServicesRoute
          })
const ServicesAeoRoute = ServicesAeoRouteImport.update({
            id: '/aeo',path: '/aeo',getParentRoute: () => ServicesRoute
          })
const ServicesAeoGeoRoute = ServicesAeoGeoRouteImport.update({
            id: '/aeo-geo',path: '/aeo-geo',getParentRoute: () => ServicesRoute
          })
const ServicesDigitalMarketingRoute = ServicesDigitalMarketingRouteImport.update({
            id: '/digital-marketing',path: '/digital-marketing',getParentRoute: () => ServicesRoute
          })
const ServicesGeoRoute = ServicesGeoRouteImport.update({
            id: '/geo',path: '/geo',getParentRoute: () => ServicesRoute
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const ToolsRobotsTesterRoute = ToolsRobotsTesterRouteImport.update({
            id: '/tools/robots-tester',path: '/tools/robots-tester',getParentRoute: () => rootRouteImport
          })
const ToolsSchemaGeneratorRoute = ToolsSchemaGeneratorRouteImport.update({
            id: '/tools/schema-generator',path: '/tools/schema-generator',getParentRoute: () => rootRouteImport
          })
const ToolsSerpSimulatorRoute = ToolsSerpSimulatorRouteImport.update({
            id: '/tools/serp-simulator',path: '/tools/serp-simulator',getParentRoute: () => rootRouteImport
          })
const BlogCategoryCategoryRoute = BlogCategoryCategoryRouteImport.update({
            id: '/category/$category',path: '/category/$category',getParentRoute: () => BlogRoute
          })
const BnBlogIndexRoute = BnBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => BnRoute
          })
const BnBlogSlugRoute = BnBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => BnRoute
          })
const BnCaseStudiesIndexRoute = BnCaseStudiesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BnCaseStudiesRoute
          })
const BnCaseStudiesSlugRoute = BnCaseStudiesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => BnCaseStudiesRoute
          })
const BnSeoServicesIndexRoute = BnSeoServicesIndexRouteImport.update({
            id: '/seo-services/',path: '/seo-services/',getParentRoute: () => BnRoute
          })
const BnSeoServicesLocationRoute = BnSeoServicesLocationRouteImport.update({
            id: '/seo-services/$location',path: '/seo-services/$location',getParentRoute: () => BnRoute
          })
const BnServicesIndexRoute = BnServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BnServicesRoute
          })
const BnServicesAeoRoute = BnServicesAeoRouteImport.update({
            id: '/aeo',path: '/aeo',getParentRoute: () => BnServicesRoute
          })
const BnServicesGeoRoute = BnServicesGeoRouteImport.update({
            id: '/geo',path: '/geo',getParentRoute: () => BnServicesRoute
          })
const BnServicesSeoRoute = BnServicesSeoRouteImport.update({
            id: '/seo',path: '/seo',getParentRoute: () => BnServicesRoute
          })
const SeoServicesLocationServiceRoute = SeoServicesLocationServiceRouteImport.update({
            id: '/$service',path: '/$service',getParentRoute: () => SeoServicesLocationRoute
          })
const SeoServicesRangpurAreaRoute = SeoServicesRangpurAreaRouteImport.update({
            id: '/seo-services/rangpur/$area',path: '/seo-services/rangpur/$area',getParentRoute: () => rootRouteImport
          })
const BnBlogCategoryCategoryRoute = BnBlogCategoryCategoryRouteImport.update({
            id: '/blog/category/$category',path: '/blog/category/$category',getParentRoute: () => BnRoute
          })
const BnSeoServicesLocationServiceRoute = BnSeoServicesLocationServiceRouteImport.update({
            id: '/$service',path: '/$service',getParentRoute: () => BnSeoServicesLocationRoute
          })





const BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,BlogIndexRoute: BlogIndexRoute,BlogCategoryCategoryRoute: BlogCategoryCategoryRoute
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)




const BnCaseStudiesRouteChildren = {
  BnCaseStudiesSlugRoute: BnCaseStudiesSlugRoute,BnCaseStudiesIndexRoute: BnCaseStudiesIndexRoute
}

const BnCaseStudiesRouteWithChildren = BnCaseStudiesRoute._addFileChildren(BnCaseStudiesRouteChildren)




const BnServicesRouteChildren = {
  BnServicesAeoRoute: BnServicesAeoRoute,BnServicesGeoRoute: BnServicesGeoRoute,BnServicesSeoRoute: BnServicesSeoRoute,BnServicesIndexRoute: BnServicesIndexRoute
}

const BnServicesRouteWithChildren = BnServicesRoute._addFileChildren(BnServicesRouteChildren)




const BnSeoServicesLocationRouteChildren = {
  BnSeoServicesLocationServiceRoute: BnSeoServicesLocationServiceRoute
}

const BnSeoServicesLocationRouteWithChildren = BnSeoServicesLocationRoute._addFileChildren(BnSeoServicesLocationRouteChildren)



const BnRouteChildren = {
  BnAboutRoute: BnAboutRoute,BnAiActionPlanRoute: BnAiActionPlanRoute,BnBookRoute: BnBookRoute,BnCaseStudiesRoute: BnCaseStudiesRouteWithChildren,BnContactRoute: BnContactRoute,BnFreeSeoAuditRoute: BnFreeSeoAuditRoute,BnOnlineMarketingSmallBusinessesRoute: BnOnlineMarketingSmallBusinessesRoute,BnPricingRoute: BnPricingRoute,BnServicesRoute: BnServicesRouteWithChildren,BnIndexRoute: BnIndexRoute,BnBlogSlugRoute: BnBlogSlugRoute,BnSeoServicesLocationRoute: BnSeoServicesLocationRouteWithChildren,BnBlogIndexRoute: BnBlogIndexRoute,BnSeoServicesIndexRoute: BnSeoServicesIndexRoute,BnBlogCategoryCategoryRoute: BnBlogCategoryCategoryRoute
}

const BnRouteWithChildren = BnRoute._addFileChildren(BnRouteChildren)




const CaseStudiesRouteChildren = {
  CaseStudiesSlugRoute: CaseStudiesSlugRoute,CaseStudiesIndexRoute: CaseStudiesIndexRoute
}

const CaseStudiesRouteWithChildren = CaseStudiesRoute._addFileChildren(CaseStudiesRouteChildren)




const SeoForRouteChildren = {
  SeoForIndustryRoute: SeoForIndustryRoute,SeoForIndexRoute: SeoForIndexRoute
}

const SeoForRouteWithChildren = SeoForRoute._addFileChildren(SeoForRouteChildren)




const ServicesRouteChildren = {
  ServicesAeoRoute: ServicesAeoRoute,ServicesAeoGeoRoute: ServicesAeoGeoRoute,ServicesDigitalMarketingRoute: ServicesDigitalMarketingRoute,ServicesGeoRoute: ServicesGeoRoute,ServicesIndexRoute: ServicesIndexRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)




const SeoServicesLocationRouteChildren = {
  SeoServicesLocationServiceRoute: SeoServicesLocationServiceRoute
}

const SeoServicesLocationRouteWithChildren = SeoServicesLocationRoute._addFileChildren(SeoServicesLocationRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AeoRoute: AeoRoute,AeoChecklistRoute: AeoChecklistRoute,AiActionPlanRoute: AiActionPlanRoute,AiAnswersRoute: AiAnswersRoute,AuthRoute: AuthRoute,BangladeshSeoRoute: BangladeshSeoRoute,BestDigitalMarketingExpertBangladeshRoute: BestDigitalMarketingExpertBangladeshRoute,BlogRoute: BlogRouteWithChildren,BnRoute: BnRouteWithChildren,BookRoute: BookRoute,CaseStudiesRoute: CaseStudiesRouteWithChildren,ContactRoute: ContactRoute,CredentialsRoute: CredentialsRoute,FreeSeoAuditRoute: FreeSeoAuditRoute,GlossaryRoute: GlossaryRoute,HowToCheckDomainAuthorityRoute: HowToCheckDomainAuthorityRoute,HowToImproveDomainAuthorityRoute: HowToImproveDomainAuthorityRoute,MozDaVsAhrefsDrRoute: MozDaVsAhrefsDrRoute,OnlineMarketingSmallBusinessesRoute: OnlineMarketingSmallBusinessesRoute,PressRoute: PressRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ProcessRoute: ProcessRoute,ResourcesRoute: ResourcesRoute,SeoExpertBangladeshRoute: SeoExpertBangladeshRoute,SeoForRoute: SeoForRouteWithChildren,SeoLocationsRoute: SeoLocationsRoute,SeoServicesBangladeshRoute: SeoServicesBangladeshRoute,SeoToolsRoute: SeoToolsRoute,SeoTrainingRoute: SeoTrainingRoute,ServicesRoute: ServicesRouteWithChildren,SitemapRoute: SitemapRoute,TestimonialsRoute: TestimonialsRoute,TrustRoute: TrustRoute,WhatIsDigitalMarketingRoute: WhatIsDigitalMarketingRoute,AdminLeadsRoute: AdminLeadsRoute,CompareSlugRoute: CompareSlugRoute,ProofSlugRoute: ProofSlugRoute,SeoServicesLocationRoute: SeoServicesLocationRouteWithChildren,ToolsRobotsTesterRoute: ToolsRobotsTesterRoute,ToolsSchemaGeneratorRoute: ToolsSchemaGeneratorRoute,ToolsSerpSimulatorRoute: ToolsSerpSimulatorRoute,CompareIndexRoute: CompareIndexRoute,ProofIndexRoute: ProofIndexRoute,SeoServicesIndexRoute: SeoServicesIndexRoute,ToolsIndexRoute: ToolsIndexRoute,SeoServicesRangpurAreaRoute: SeoServicesRangpurAreaRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)